import dayjs from 'dayjs';
import type { DateISO } from '@vgtv/api-client';

export interface ProgrammeItem {
  title: string;
  description?: string;
  starttime?: string;
}

export interface TimetableItem {
  title: string;
  description?: string;
  startTime: DateISO;
  endTime?: DateISO;
  time: string;
}

export const createTimetableFromProgramme = (programme: ProgrammeItem[]) => {
  return programme.reduce<Record<string, TimetableItem[]>>(
    (acc, curr, index, original) => {
      const nextStartTime = original[index + 1]?.starttime;

      const record = {
        title: curr.title,
        description: curr.description,
        startTime: dayjs(curr.starttime).toISOString(),
        endTime: nextStartTime ? dayjs(nextStartTime).toISOString() : undefined,
        time: dayjs(curr.starttime).format('HH:mm'),
      };

      const startTimeKey = dayjs(curr.starttime).format('YYYY-MM-DD');

      if (!(startTimeKey in acc)) {
        acc[startTimeKey] = [];
      }

      acc[startTimeKey].push(record);

      if (!nextStartTime) {
        return acc;
      }

      const endTimeKey = dayjs(nextStartTime).format('YYYY-MM-DD');

      if (startTimeKey === endTimeKey) {
        return acc;
      }

      if (!(endTimeKey in acc)) {
        acc[endTimeKey] = [];
      }

      acc[endTimeKey].push(record);

      return acc;
    },
    {}
  );
};

export const getTimetableLastDay = (timetable: Record<string, unknown>) => {
  const maxDate = Math.max(
    ...Object.keys(timetable).map((date) => dayjs(date).valueOf())
  );

  return dayjs(isFinite(maxDate) ? maxDate : undefined).format('YYYY-MM-DD');
};
